// React  dependencies
import React, { Component } from 'react';

// External dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RadioGroup, FormControlLabel, Radio, Button } from '@material-ui/core';
import { toast } from 'react-toastify';

// Internal dependencies
import Constants from '../../common/constants';
import { getPage, updatePageStatus } from '../../actions/admin/pageAction';

// Components
import OverLoading from '../global/OverLoading';

class PageStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status:  Constants.PageStatus.Pending,
      loading: false,
    };
    this.pageId = this.props.match.params.id;
  }

  componentDidMount() {
    this.getPageData(this.pageId);
  }

  getPageData = async (id) => {
    try {
      const page = await this.props.getPage(id);
      this.setState({ status: page.status });
    } catch (err) {
      toast.error('Unable to retrieve page data');
    }
  }

  async performStatusUpdate() {
    try {
      this.setState({ loading: true });

      await this.props.updatePageStatus(this.pageId, this.state.status);
      toast.success('Page status updated');
    } catch (err) {
      toast.error(err);
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <>
        { this.state.loading && <OverLoading />}
        <div className="container">
          <div className="row">
            <h1>Page Status</h1>
          </div>
          <div className="row" style={{ marginTop: 20 }}>
            <h5>Change:</h5>
          </div>

          <div className="row" style={{ marginTop: 10 }}>
            <div className="form-group">
              <RadioGroup
                row
                aria-label="status"
                name="status"
                value={this.state.status}
                onChange={(e) => this.setState({ status: e.target.value })}
              >
                <FormControlLabel
                  value={Constants.PageStatus.Pending}
                  control={<Radio color="default" />}
                  label={Constants.PageStatus.Pending}
                />
                <FormControlLabel
                  value={Constants.PageStatus.Live}
                  control={<Radio color="primary" />}
                  label={Constants.PageStatus.Live}
                />
                <FormControlLabel
                  value={Constants.PageStatus.Rejected}
                  control={<Radio color="secondary" />}
                  label={Constants.PageStatus.Rejected}
                />
              </RadioGroup>
            </div>
          </div>

          <div className="row">
            <Button onClick={() => this.performStatusUpdate()} variant="contained" color="primary">Update</Button>
          </div>
        </div>
      </>
    );
  }
}

PageStatus.propTypes = {
  match: PropTypes.shape(Object).isRequired,

  getPage:          PropTypes.func.isRequired,
  updatePageStatus: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getPage,
  updatePageStatus,
};

export default connect(null, mapDispatchToProps)(PageStatus);
